import React from "react"
import customArrowStyles from "./CarouselCustomArrows.module.css"

export const CarouselCustomLeftArrow = ({ onClick }) => {
  return (
    <button
      onClick={() => onClick()}
      className={`
        react-multiple-carousel__arrow
        react-multiple-carousel__arrow--left
        ${customArrowStyles.arrow}
        ${customArrowStyles.leftArrow}
      `}
    />
  );
}

export const CarouselCustomRightArrow = ({ onClick }) => {
  return (
    <button
      onClick={() => onClick()}
      className={`
        react-multiple-carousel__arrow
        react-multiple-carousel__arrow--right
        ${customArrowStyles.arrow}
        ${customArrowStyles.rightArrow}
      `}
    />
  );
}

